import parse from "html-react-parser";
import React from "react";
import { brand } from "../../assets/images/icons";
import { loggedInUrl } from "../../bridges/deeplinkUrlConfig";

const LoginHeader = () => {
  return (
    <div className="login-header">
      <a href="/">{parse(brand)}</a>
      <a href={loggedInUrl} className="login-link">
        LOGIN
      </a>
    </div>
  );
};

export default LoginHeader;
